import Vue from "vue";

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {},
  actions: {
    fetchStockOut(ctx, params) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$rf
          .getRequest("CommonRequest")
          .getWarehouseStockout(params)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    createStockOut(ctx, params) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$rf
          .getRequest("CommonRequest")
          .createStockout(params)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    }
  },
};
